export default "__VITE_ASSET__B4US7mDn__"